import React, { useState } from 'react';
import Button from '../../../../../Components/Button/Button';
import TitleText from '../../../../../Components/TitleText/TitleText';
import Project from '../Project/Project';
import './Projects.css';

const Projects = (props) => {

    const [visible, setVisible] = useState(4);

    const showMoreProjects = () => {
        setVisible((prevVisible) => prevVisible + 2);
    };

    const showLessProjects = () => {
        setVisible((prevVisible) => prevVisible = 4);

    };

    return (
        <div id="projects"  >

            <div className='container home-projects-container '>

                <div className='row' >
                    <TitleText title1="OUR" title2="PROJECTS" position="center" />
                    {
                        props.projects.slice(0, visible).map((project) =>
                            <Project key={project.id} project={project} />

                        )
                    }

                </div>

               { 
               props.projects.length > 4?(
                <>
                <div className='home-load-btn' >
                    {
                        (props.projects || []).length > visible && (

                            <div className="col-md-12  text-center">

                                <Button title="LOAD MORE" onClick={showMoreProjects} />
                            </div>
                        )

                    }
                    {
                        (props.projects || []).length <= visible &&  (

                            <div className="col-md-12 text-center">
                                <Button title="LOAD LESS" onClick={showLessProjects} />
                            </div>
                        )
                    }
                </div>
                </>
               ):<>
               
               </>
               }


            </div>
        </div>
    );
};

export default Projects;